import styled from 'styled-components';
import { Banner } from 'ui/banner';
import { BannerVariants } from 'ui/banner/types';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const StyledBanner = styled(Banner)`
  > * {
    text-align: center;
  }
  margin: -${spacing.layoutTopPadding} min(
      calc((100vw - ${spacing.normalPageMaxWidth}) / -2),
      -${spacing.layoutLRPadding}
    ) 0 min(calc((100vw - ${spacing.normalPageMaxWidth}) / -2), -${spacing.layoutLRPadding});
  padding-top: ${pxToRem(10)};
  padding-bottom: ${pxToRem(10)};
`;

export const SUSPEND_SENDS_TEST_ID = 'suspend-sends-test-id';

export const SuspendSendsBanner = () => (
  <StyledBanner variant={BannerVariants.WARNING} data-test={SUSPEND_SENDS_TEST_ID}>
    Sends have been suspended for this project. Please contact your CSM for more info.
  </StyledBanner>
);
